<script setup lang="ts">
import {$injByInterface} from '@/common/decorators/depinject.ts'
import {computed, onMounted, ref} from 'vue'
import type IColourSchemeUtils from '@/common/services/IColorSchemeUtil.ts'
import {VsgFlexWrapper} from '@jack-henry/jha-vue-components'
import {useRoute} from 'vue-router'
import {AdminStatesConstant} from '@/branchmanager/app/constant/AdminStatesConstant.ts'
import {WorkspaceStatesConstant} from '@/branchmanager/app/constant/WorkspaceStatesConstant.ts'

const colorSchemeUtil = $injByInterface<IColourSchemeUtils>('IColourSchemeUtils')
const logoBase64 = ref<string>('')
const fiName = ref<string>(window.institutionConfig.name)
const route = useRoute()

onMounted(() => {
  logoBase64.value = colorSchemeUtil.onColorSchemeChange()
})

const STATES_WITH_BANNERS = [
  AdminStatesConstant.RULES_EDITOR.STATE,
  AdminStatesConstant.WORKFLOW_ADMIN_EDIT.STATE,
  WorkspaceStatesConstant.WORKSPACE_DETAIL.STATE,
  AdminStatesConstant.QUESTIONNAIRE_ADMIN_EDIT.STATE,
  WorkspaceStatesConstant.SEARCH_CUSTOMER.STATE,
  WorkspaceStatesConstant.WORKFLOW.STATE
]

const STATES_TO_HIDE_JH_LOGO = [
  WorkspaceStatesConstant.LOGIN.STATE
]

const statePath = computed(() => route.matched)
const hideBanner = computed(() =>
  STATES_WITH_BANNERS.some(state => statePath.value.some(path => path.name == state))
)
const hideLogo = computed(() =>
  STATES_TO_HIDE_JH_LOGO.some(state => statePath.value.some(path => path.name == state))
)

</script>

<template>
  <vsg-flex-wrapper
    space-between
    v-if="!hideBanner"
    id="jh-logo-banner">
    <img
      v-if="!hideLogo"
      class="jh-logo"
      src="./images/logo.png"
      alt="Jack Henry" />

    <img
      v-if="logoBase64.length"
      :src="logoBase64"
      :alt="fiName"
      class="fi-logo" />
  </vsg-flex-wrapper>
</template>

<style scoped>
#jh-logo-banner {
  background: white;
  border-bottom: 1px solid #ddd;
  height: var(--jh-logo-banner-height);
  padding: 0 var(--jh-space-400);
}

.jh-logo,
.fi-logo {
  height: 100%;
  max-width: 100%;
  width: auto;
  object-fit: contain;
}

.jh-logo {
  padding: var(--jh-space-200) 0;
}

.fi-logo {
  padding: var(--jh-space-400) 0;
}

@media (max-width: 550px) {
  .fi-logo {
    display: none;
  }
}
</style>